'use strict';

var base = require('base/search/search');

/**
 * When a new sort option is selected, triggers an AJAX request to fetch the sorted info
 */
base.sort = function () {
    // Handle sort order menu selection
    $('.container').on('change', '[name=sort-order]', function (e) {
        e.preventDefault();
        $.spinner().start();
        $(this).trigger(
            'search:sort',
            this.options[this.selectedIndex].dataset.url
        );
        $.ajax({
            url: this.options[this.selectedIndex].dataset.url,
            data: { selectedUrl: this.options[this.selectedIndex].dataset.url },
            method: 'GET',
            success: function (response) {
                $('.product-grid').empty().html(response);
                $('body').trigger('search:updateDom', '.product-grid');
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
};

/**
 * Keep SEO/context-aware refinement URL for both browser URL and AJAX request.
 * This avoids mismatches where AJAX hits a non-context URL and returns different results.
 */
base.applyFilter = function () {
    $('.container').on(
        'click',
        '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button',
        function (e) {
            e.preventDefault();
            e.stopPropagation();

            $.spinner().start();
            $(this).trigger('search:filter', e);

            var rawHref = $(this).data('href');
            var seoHref = $(this).data('seo-href');
            var ajaxUrl = rawHref || seoHref;
            var historyUrl = seoHref || rawHref;
            if (!ajaxUrl) {
                $.spinner().stop();
                return;
            }

            if (historyUrl) {
                window.history.pushState({}, null, historyUrl);
            }

            var attributeId = '#' + $(this).find('span').last().attr('id');
            $.ajax({
                url: ajaxUrl,
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: ajaxUrl
                },
                method: 'GET',
                success: function (response) {
                    var $results = $(response);

                    // Empty-category responses use a different layout (no .container.search-results).
                    // In that case, force a full page load to guarantee consistent rendering.
                    if ($results.find('.container.search-results').length === 0) {
                        window.location.href = historyUrl || ajaxUrl;
                        return;
                    }

                    [
                        '.grid-header',
                        '.header-bar',
                        '.header.page-title',
                        '.plp-category-description',
                        '.product-grid',
                        '.show-more',
                        '.filter-bar',
                        '.refinements'
                    ].forEach(function (selector) {
                        var $updates = $results.find(selector);
                        $(selector).empty().html($updates.html());
                        $('body').trigger('search:updateDom', selector);
                    });
                    $.spinner().stop();
                    $(attributeId).parent('button').focus();
                },
                error: function () {
                    $.spinner().stop();
                    $(attributeId).parent('button').focus();
                }
            });
        }
    );
};

module.exports = base;
